export default __webpack_public_path__ + "static/media/threeVerticalDots.551ec797.svg";